import { store } from "index"

export const getActiveKeys = () => {
    return store.getState().keys.data.filter(key => key.isActive)
}